import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

var DetailModal = function (_super) {
  __extends(DetailModal, _super);

  function DetailModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.columns = [{
      title: _this.t('箱号'),
      dataIndex: 'box_no'
    }, {
      title: _this.t('箱麦参考号'),
      dataIndex: 'shipping_mark',
      filterEmpty: true
    }, {
      title: _this.t('异常原因'),
      dataIndex: 'exception_surface_info',
      filterEmpty: true,
      width: 300
    }];
    _this.detaildata = DetailModal_1.initData();
    return _this;
  }

  DetailModal_1 = DetailModal;

  DetailModal.initData = function () {
    return {
      box_list: [],
      forecast_box_num: 0,
      exception_box_num: 0,
      total: 0
    };
  };

  DetailModal.prototype.onVisibleChange = function (value) {
    if (value) {
      this.queryLogisticsAgentAbnormalDetail({
        gc_fba_order_code: this.data.gc_fba_order_code
      });
    }
  };

  DetailModal.prototype.queryLogisticsAgentAbnormalDetail = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.internationalDelivery.queryLogisticsAgentAbnormalDetail(param)];

          case 1:
            res = _a.sent();
            this.detaildata = res.data;
            return [2];
        }
      });
    });
  };

  var DetailModal_1;

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return DetailModal_1.initData();
    }
  })], DetailModal.prototype, "data", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], DetailModal.prototype, "onVisibleChange", null);

  DetailModal = DetailModal_1 = __decorate([Component], DetailModal);
  return DetailModal;
}(Vue);

export default DetailModal;